import React, { Suspense } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
const DesktopIndex = React.lazy(() => import('./DesktopIndex'));
const MobileIndex = React.lazy(() => import('./MobileIndex'));

const FastSkeleton = () => (
  <div className="min-h-screen bg-slate-900 w-full animate-pulse flex flex-col pt-32 px-10">
    <div className="h-12 bg-slate-800/50 rounded-xl w-3/4 mb-6"></div>
    <div className="h-8 bg-slate-800/40 rounded-lg w-1/2 mb-10"></div>
    <div className="flex gap-4 mb-20">
      <div className="h-14 w-40 bg-blue-600/20 rounded-xl"></div>
      <div className="h-14 w-40 bg-slate-800/40 rounded-xl"></div>
    </div>
    <div className="w-full h-80 bg-slate-800/30 rounded-[2rem]"></div>
  </div>
);

const Index = () => {
  const isMobile = useIsMobile();

  return (
    <Suspense fallback={<FastSkeleton />}>
      {isMobile ? <MobileIndex /> : <DesktopIndex />}
    </Suspense>
  );
};

export default Index;